"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stylesMap = void 0;
var ImageProps_1 = require("./ImageProps");
var styles = require("./Image.css");
exports.stylesMap = new Map([
    [ImageProps_1.ImageTypes.FRAME, styles.imageFrame],
    [ImageProps_1.ImageTypes.CLICK, styles.imageClick],
]);
//# sourceMappingURL=ImageStylesMaps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Image/ImageStylesMaps.js
// module id = 1153
// module chunks = 8